/* 趙雲傳・第 2 章：桂陽郡治郴縣（209 年）
 * 城在中間（木石城牆，東西各一座城門），城裡有郡府、府庫、市；城外三處鄉里。趙雲從西邊來，趙範夜裡從東門走。 */
export const CITY = { x: 4400, y: 2500, hw: 900, hh: 560 };
const T = 30, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw, G = 130;
export const WGATE = [Wx, CITY.y], EGATE = [E, CITY.y], FU = [4400, 2150], KU = [3850, 2780], SHI = [4950, 2780], START = [900, 2500];
export const XIANG = [[1900, 1200], [1800, 3900], [7000, 3800]];
const vseg = (x: number, y0: number, y1: number) => [x, (y0 + y1) / 2, T, (y1 - y0) / 2];
export default {
  id: 'zhaoyun_guiyang', name: '桂陽', W: 8000, H: 5000, seed: 2092,
  bases: [START, [CITY.x, CITY.y]],
  walls: [[CITY.x, N, CITY.hw + T, T], [CITY.x, S, CITY.hw + T, T], vseg(Wx, N, CITY.y - G), vseg(Wx, CITY.y + G, S), vseg(E, N, CITY.y - G), vseg(E, CITY.y + G, S)],
  roads: [
    { pts: [START, [2600, 2450], WGATE, [CITY.x, CITY.y], EGATE, [6200, 2400], [7900, 2300]], w: 150 },
    { pts: [FU, [CITY.x, CITY.y], [CITY.x, 2900]], w: 120 },
    { pts: [KU, [4100, 2650], [CITY.x, CITY.y], [4700, 2650], SHI], w: 110 },
    { pts: [[2600, 2450], XIANG[0]], w: 100 }, { pts: [[2600, 2450], XIANG[1]], w: 100 }, { pts: [[6200, 2400], XIANG[2]], w: 100 },
  ],
  rocks: [[6300, 1100, 480, 220], [1000, 4200, 380, 180], [5600, 4200, 420, 200]],
  woods: 0.4,
  sight: 0.9,
  clearings: [[CITY.x, CITY.y, 1050], ...XIANG.map(([x, y]) => [x, y, 420]), [START[0], START[1], 400]],
  villages: [{ x: CITY.x, y: CITY.y, n: 9, r: 520 }, ...XIANG.map(([x, y]) => ({ x, y, n: 4, r: 260 }))],
  fields: [[XIANG[0][0] + 450, XIANG[0][1] + 150, 420, 220], [XIANG[1][0] + 450, XIANG[1][1] - 150, 420, 220], [XIANG[2][0] - 450, XIANG[2][1] - 150, 420, 220, '#86803f']],
};
